const bybcat = {

  "bybcat.page.title": "BYBCAT",
  "bybcat.page.welcome": "Welcome to BYBCAT!",
  "bybcat.page.instructions_1": "Please select your name",
  "bybcat.page.instructions_2": "Choose your control scheme and warm up. Once you feel ready, start the test.",
  "bybcat.page.instructions_3": "There are no scheduled tests.\nPlease schedule a test in the Portal to begin.",
  "bybcat.page.settings.title": "Test Settings",
  "bybcat.page.completed_title": "Test Complete",
  "bybcat.page.completed_body": "Your results have been saved\nThank you for participating!",
  "bybcat.page.schedule.for_user": "Select Users",
  "bybcat.page.schedule.for_group": "Select Groups",
  "bybcat.users": "users",
  "bybcat.groups": "groups",
  "bybcat.search.groups": "Search groups...",
  "bybcat.search_configs": "Search tests...",
  "bybcat.search_users": "Search users...",

  "bybcat.metric.wm": "Working Memory",
  "bybcat.metric.pr": "Pattern Recognition",
  "bybcat.metric.scanrate": "Scan Rate",
  "bybcat.metric.scantiming": "Scan Timing",
  "bybcat.metric.inhibition": "Inhibition",

  "bybcat.metric.long.wm": "Working Memory (%)",
  "bybcat.metric.long.pr": "Pattern Recognition (%)",
  "bybcat.metric.long.scanrate": "Scan Rate (Scans/Sec)",
  "bybcat.metric.long.scantiming": "Scan Timing (%)",
  "bybcat.metric.long.inhibition": "Inhibition (%)",

  "bybcat.unit.wm": "%",
  "bybcat.unit.pr": "%",
  "bybcat.unit.scanrate": "Scans/Sec",
  "bybcat.unit.scantiming": "%",
  "bybcat.unit.inhibition": "%",
  // Benchmarks
  "bybcat.benchmark.overallsds": "All Your Players",
  "bybcat.benchmark.playersds": "Current Player",
  "bybcat.benchmark.bybbenchmarksds": "BYB Benchmark",

  "bybcat.button.start": "Start",
  "bybcat.label.controls": "Active Controller",
  "bybcat.controls.left": "Always Left",
  "bybcat.controls.right": "Always Right",
  "bybcat.controls.dynamic": "Last Pressed",
  "bybcat.button.import_users": "Import Users",
  
  "bybcat.label.general": "General",
  "bybcat.label.warmup": "Warm Up",
  "bybcat.label.wm": "Working Memory",
  "bybcat.label.pr": "Pattern Recognition",
  "bybcat.label.inhibition": "Inhibition",
  "bybcat.label.settings": "Settings",
  "bybcat.label.settings.test_code": "Test Code",
  "bybcat.label.settings.test_code_caption": "The test code decides what scenarios are used in the test. Use the recommended code or enter your own within 1 to 99999",
  "bybcat.label.settings.slice_length": "Slice Length",
  "bybcat.label.settings.slice_count": "Slice Count",
  "bybcat.label.settings.min_slice_speed": "Minimum Slice Speed",
  "bybcat.label.settings.max_slice_speed": "Maximum Slice Speed",
  "bybcat.label.settings.warmup_code": "Test Code",
  "bybcat.label.settings.warmup_speed": "Game Speed",
  "bybcat.label.settings.warmup_neutral_count": "Neutral Scenarios Count",
  "bybcat.label.settings.warmup_inhibition_count": "Inhibition Test Count",
  "bybcat.label.settings.warmup_pr_count": "Pattern Recognition Test Count",
  "bybcat.label.settings.warmup_wm_count": "Working Memory Test Count",
  "bybcat.label.settings.wm_count": "Tests Per Slice",
  "bybcat.label.settings.wm_subject_count": "Subjects Per Test",
  "bybcat.label.settings.wm_max_incorrect_answers": "Maximum Incorrect Answers",
  "bybcat.label.settings.wm_duration": "Test Duration (seconds)",
  "bybcat.label.settings.wm_minimum_game_time": "Minimum Game Time (seconds)",
  "bybcat.label.settings.pr_count": "Tests Per Slice",
  "bybcat.label.settings.pr_subject_count": "Subjects Per Test",
  "bybcat.label.settings.pr_max_incorrect_answers": "Maximum Incorrect Answers",
  "bybcat.label.settings.pr_duration": "Test Duration (seconds)",
  "bybcat.label.settings.pr_minimum_game_time": "Minimum Game Time (seconds)",
  "bybcat.label.settings.inhibition_count": "Tests Per Slice",
  "bybcat.label.settings.inhibition_duration": "Test Duration (seconds)",

  "bybcat.page.schedule.loading_schedule": "Scheduling test...",
  "bybcat.page.schedule.loading_results": "Loading results...",
  "bybcat.page.schedule.loading_configs": "Loading tests...",
  "bybcat.page.schedule.loading_users": "Loading users...",

  // Config List Page
  "bybcat.page.configs.title": "My Tests",
  "bybcat.button.create_config": "Create New Test",
  "bybcat.page.configs.no_configs": "No tests found",

  // User List Page
  "bybcat.page.users.title": "My Users",
  "bybcat.page.groups.title": "My Groups",
  "bybcat.button.create_user": "Create New User",
  "bybcat.dialog.create_user.title": "Create New User",
  "bybcat.dialog.update_user.title": "Edit User",
  "bybcat.page.users.no_users": "No users found",
  
  // Schedule Test Page
  "bybcat.page.schedule.title": "Schedule Test",
  "bybcat.page.schedule.select_user": "Select User",
  "bybcat.page.schedule.select_config": "Select Test",
  "bybcat.button.schedule_test": "Schedule Test",
  "bybcat.page.schedule.loading": "Scheduling test...",
  "bybcat.button.results": "See Results",

  // Common Labels
  "label.name": "Name",
  "label.email": "Email",
  "label.birth_date": "Birth Date",
  "button.cancel": "Cancel",
  "button.create": "Create",

  // Config Page
  "bybcat.button.edit_config": "Edit",
  "bybcat.label.scheduled_tests": "Scheduled Tests",
  "bybcat.label.completed_tests": "Completed Tests",
  "bybcat.label.no_scheduled_tests": "No scheduled tests",
  "bybcat.label.no_completed_tests": "No completed tests",
  "bybcat.button.add_users": "Add Users",
  
  // Status Labels
  "bybcat.status.scheduled": "Scheduled",
  "bybcat.status.in_progress": "In Progress",
  "bybcat.status.complete": "Complete",
  "bybcat.status.incomplete": "Incomplete",

  // Config Editor
  "bybcat.editor.title": "Configuration Editor",
  "bybcat.editor.general_settings": "General Settings",
  "bybcat.editor.test_settings": "Test Settings",
  "bybcat.editor.save": "Save Changes",
  "bybcat.editor.cancel": "Cancel",
  
  // Config List
  "bybcat.configs.create": "Create New Configuration",
  "bybcat.configs.empty": "No configurations found",
  "bybcat.configs.search": "Search configurations",
  
  // Common Actions
  "bybcat.action.view": "View",
  "bybcat.action.edit": "Edit",
  "bybcat.action.delete": "Delete",
  "bybcat.action.schedule": "Schedule Test",
  
  // Messages
  "bybcat.message.config_saved": "Configuration saved successfully",
  "bybcat.message.config_deleted": "Configuration deleted successfully",
  "bybcat.message.test_scheduled": "Test scheduled successfully",
  
  // Confirmations
  "bybcat.confirm.delete_config": "Are you sure you want to delete this configuration?",
  "bybcat.confirm.discard_changes": "Are you sure you want to discard your changes?",

  // Search
  "bybcat.search.users": "Search users...",
  "bybcat.search.no_results": "No users found",

  "bybcat.tooltip.cannot_edit_config_with_results": "This configuration has results and can no longer be edited.",

  // Delete Result
  "bybcat.confirm.delete_result.title": "Delete Scheduled Test",
  "bybcat.confirm.delete_result.message": "Are you sure you want to delete this scheduled test? This action cannot be undone.",
  "button.delete": "Delete",
}

export {
  bybcat
}
